import React from 'react';
import Service from '../components/Service.jsx';
const ServicePage = () => {
    return (
        <div>
            <Service></Service>
        </div>
    )
};
export default ServicePage;